import registrationModalLoginInstance from '../../modalLoginInstance'

const postModalLogout = (refreshToken) => {
  return registrationModalLoginInstance.post('/auth/logout', { refreshToken })
}

export default postModalLogout
